import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import CurrentBalanceDetail from './CurrentBalanceDetail'

const CurrentBalance = ({ accountHistory, className }) => (
  <div className={className}>
    <h3 className="small-h3">Current Balance</h3>
    <CurrentBalanceDetail amount={accountHistory.balanceOwed} text="Current Balance (Owed)" />
    <CurrentBalanceDetail
      amount={accountHistory.creditLimit - accountHistory.balanceOwed}
      text="Available Credit"
    />
    <CurrentBalanceDetail amount={accountHistory.creditLimit} text="Credit Line" />
  </div>
)

CurrentBalance.defaultProps = {
  className: '',
}

CurrentBalance.propTypes = {
  accountHistory: PropTypes.shape({
    balanceOwed: PropTypes.number,
    creditLimit: PropTypes.number,
    daysOverdue: PropTypes.number,
  }).isRequired,
  className: PropTypes.string,
}

const StyledCurrentBalance = styled(CurrentBalance)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.coolGray.cool450}`,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  marginBottom: '40px',
  paddingBottom: '45px',
  '.small-h3': {
    flex: '1 0 100%',
  },
  '@media(min-width: 1200px)': {
    flexDirection: 'row',
  },
}))

export default StyledCurrentBalance
